import { createFileRoute } from "@tanstack/react-router";

import { ComplianceTaskInstanceCompletion } from "@/components/compliance/instance-completion";
import { FeatureGate } from "@/components/shared/FeatureGate";
import { FEATURES } from "@/lib/features";

export const Route = createFileRoute(
  "/_authenticated/compliance/instance/$instanceId",
)({
  component: ComplianceTaskInstancePage,
});

function ComplianceTaskInstancePage() {
  const { instanceId } = Route.useParams();

  return (
    <FeatureGate
      feature={FEATURES.COMPLIANCE_TASKS}
      featureName="Compliance tasks"
    >
      <ComplianceTaskInstanceCompletion instanceId={instanceId} />
    </FeatureGate>
  );
}
